export default "__VITE_ASSET__CTXhvhlT__"